/*
 * Api.
 */

export function buildPerformanceObserver(callback: PerformanceObserverCallback) {
  return new PerformanceObserver(callback);
}
